import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { EditAssociationTagsComponent } from '../../edit-association-tags/edit-association-tags.component';
import { PRIMARY_TAG, RESERVED_TAGS } from '../../../../constants';
import { AssociationInterface } from '@vendasta/crm';

export interface EditAssociationTagsData {
  associationName: string;
  association: AssociationInterface;
}
export interface EditAssociationTagsResponse {
  updatedTags: string[];
  proceed: boolean;
}

@Component({
  selector: 'crm-edit-association-tags-dialog',
  imports: [CommonModule, TranslateModule, MatDialogModule, MatButtonModule, EditAssociationTagsComponent],
  templateUrl: './edit-association-tags-dialog.component.html',
  styleUrls: ['./edit-association-tags-dialog.component.scss'],
})
export class EditAssociationTagsDialogComponent {
  private readonly initialTags = (this.data.association?.tags || []).map((tag) => tag?.tagValue ?? '');
  protected readonly displayTags = this.initialTags.filter(
    (tag) => tag !== '' && !RESERVED_TAGS.includes(tag.toLowerCase()),
  );

  private readonly isPrimary = this.initialTags.includes(PRIMARY_TAG);
  protected readonly associationType = this.data.association?.associationType ?? '';
  protected tagsToSave: string[] = [];

  constructor(
    private readonly dialogRef: MatDialogRef<EditAssociationTagsDialogComponent, EditAssociationTagsResponse>,
    @Inject(MAT_DIALOG_DATA) protected readonly data: EditAssociationTagsData,
  ) {}

  save(): void {
    if (this.displayTags === this.tagsToSave) {
      this.dialogRef?.close({ proceed: false, updatedTags: [] });
    } else {
      const tagsToSave = this.isPrimary ? [PRIMARY_TAG, ...this.tagsToSave] : this.tagsToSave;
      this.dialogRef.close({ proceed: true, updatedTags: tagsToSave });
    }
  }

  cancel(): void {
    this.dialogRef?.close({ proceed: false, updatedTags: [] });
  }

  tagsChanged(tags: string[]): void {
    this.tagsToSave = tags || [];
  }
}
